import { render, staticRenderFns } from "./FallbackChart.vue?vue&type=template&id=6fe0b8f2&"
import script from "./FallbackChart.vue?vue&type=script&lang=js&"
export * from "./FallbackChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports